import clsx from "clsx"
import { FC } from "react"
import styles from "./AchievementCard.module.scss"

interface IAchievementCard {
  icon: string
  level: number
  isStaker?: boolean
}

export const AchievementCard: FC<IAchievementCard> = ({
  icon,
  level,
  isStaker
}) => {
  return (
    <div
      className={clsx(styles.AchievementCard, { [styles.staker]: isStaker })}
    >
      <img src={icon} alt="icon" />
      <div className={clsx(styles.AchievementCard_level)}>{level}</div>
    </div>
  )
}
